<template>
  <div class="col-lg-12">
    <ejs-treeview ref='measureTreeForDataQuery' :fields='fieldsOfMeasureTreeForDataQuery' :showCheckBox='true' :nodeChecked="measureTreeNodeChecked" :nodeSelected="measureTreeNodeSelected"></ejs-treeview>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'NoRealTaskMeasureTreeForDataSearch',
  data() {
    return {
      fieldsOfMeasureTreeForDataQuery: {
        dataSource: [],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      nodeCheckIdList:[],
      nodeCheckInfoList: []

    }
  },
  methods: {

    measureTreeNodeSelected(args){
      let checkedNode = [args.node]
      if(args.nodeData.isChecked == "false") {
        this.$refs.measureTreeForDataQuery.checkAll(checkedNode);
      } else {
        this.$refs.measureTreeForDataQuery.uncheckAll(checkedNode);
      }
    },

    measureTreeNodeChecked(args) {

      // 获取点击的节点信息

      let checkedNodeInfoList = args.data.filter(function (checkedNode) {
        return checkedNode.hasChildren == false;
      }).map(function (checkedNode) {
        return checkedNode;
      });

      let checkedNodeIds = checkedNodeInfoList.map(function(checkedNode){
        return checkedNode.id;
      })


      // 获取点击状态 check/uncheck
      const checkStatus = args.action;

      // 如果状态为点击，将点击的节点添加到点击节点列表中
      if(checkStatus == "check"){
        for(let checkedNode of checkedNodeInfoList){
          this.nodeCheckIdList.push(checkedNode.id);
          this.nodeCheckInfoList.push(checkedNode);
        }
      // 如果状态为取消点击，从点击节点列表中删除对应元素
      }else if(checkStatus == 'uncheck' ){
        this.nodeCheckIdList = this.nodeCheckIdList.filter(function(nodeCheckedId){
          return checkedNodeIds.indexOf(nodeCheckedId) == -1;
        });
        this.nodeCheckInfoList = this.nodeCheckInfoList.filter(function (nodeChecked) {
          return checkedNodeIds.indexOf(nodeChecked.id) == -1
        })
      }
    },
    getMeasureTreeForData(neId,neTypeCode,measureObjCode){
      const params = {
        neTypeCode,
        neId,
        measureObjCode
      }
      this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskCounterTreeForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fieldsOfMeasureTreeForDataQuery = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>
